// Map league names to short codes and colors for badges
export function getLeagueBadge(leagueName: string | null | undefined): { code: string; color: string } {
  if (!leagueName) return { code: '?', color: 'var(--muted)' }

  const name = leagueName.toLowerCase()
  if (name.includes('premier')) return { code: 'PL', color: '#3d195b' }
  if (name.includes('championship')) return { code: 'CH', color: '#ff6900' }
  if (name.includes('league one')) return { code: 'L1', color: '#e30613' }
  if (name.includes('league two')) return { code: 'L2', color: '#00a651' }
  if (name.includes('la liga')) return { code: 'LL', color: '#ee8707' }
  if (name.includes('bundesliga')) return { code: 'BL', color: '#d20515' }
  if (name.includes('serie a')) return { code: 'SA', color: '#024494' }
  if (name.includes('ligue 1')) return { code: 'L1', color: '#dae025' }
  if (name.includes('fa cup')) return { code: 'FA', color: '#c8102e' }
  if (name.includes('efl cup') || name.includes('league cup') || name.includes('carabao')) return { code: 'LC', color: '#00a651' }
  if (name.includes('champions')) return { code: 'CL', color: '#0e1e5b' }
  if (name.includes('europa league')) return { code: 'EL', color: '#f68e1f' }
  if (name.includes('conference')) return { code: 'EC', color: '#19b24b' }
  if (name.includes('community shield')) return { code: 'CS', color: '#e31b23' }

  return { code: leagueName.substring(0, 2).toUpperCase(), color: 'var(--muted)' }
}

// Map league names to logo URLs (using API-Football's media CDN)
export function getLeagueLogo(leagueName: string | null | undefined): string | null {
  if (!leagueName) return null

  const name = leagueName.toLowerCase()

  // API-Football league IDs mapped to their logos
  const leagueLogos: Record<string, string> = {
    'premier league': 'https://media.api-sports.io/football/leagues/39.png',
    'championship': 'https://media.api-sports.io/football/leagues/40.png',
    'league one': 'https://media.api-sports.io/football/leagues/41.png',
    'league two': 'https://media.api-sports.io/football/leagues/42.png',
    'la liga': 'https://media.api-sports.io/football/leagues/140.png',
    'bundesliga': 'https://media.api-sports.io/football/leagues/78.png',
    'serie a': 'https://media.api-sports.io/football/leagues/135.png',
    'ligue 1': 'https://media.api-sports.io/football/leagues/61.png',
    'fa cup': 'https://media.api-sports.io/football/leagues/45.png',
    'efl cup': 'https://media.api-sports.io/football/leagues/46.png',
    'carabao cup': 'https://media.api-sports.io/football/leagues/46.png',
    'league cup': 'https://media.api-sports.io/football/leagues/46.png',
    'champions league': 'https://media.api-sports.io/football/leagues/2.png',
    'uefa champions league': 'https://media.api-sports.io/football/leagues/2.png',
    'europa league': 'https://media.api-sports.io/football/leagues/3.png',
    'uefa europa league': 'https://media.api-sports.io/football/leagues/3.png',
    'conference league': 'https://media.api-sports.io/football/leagues/848.png',
    'uefa europa conference league': 'https://media.api-sports.io/football/leagues/848.png',
    'community shield': 'https://media.api-sports.io/football/leagues/528.png',
  }

  // Try exact match first
  for (const [key, url] of Object.entries(leagueLogos)) {
    if (name.includes(key)) return url
  }

  return null
}
